import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import MultiSelect from "../stop-finder/MultiSelect";
import { getFilteredStops } from "./utils";

function AtlasMenuFilters(props) {
    const { filters, setFilters, closeModal, tags, stops } = props;
    const multiSelectRef = useRef();
    const [totalResults, setTotalResults] = useState(null);
    const clearFilters = () => {
        multiSelectRef.current.resetSelectedValues();
        setTotalResults(null);
    };
    const handleSubmit = event => {
        event.preventDefault();
        setFilters(multiSelectRef.current.getSelectedItems());
        closeModal();
    };
    const onChange = useCallback(
        _filters => {
            const filteredStops = getFilteredStops(stops, _filters);
            setTotalResults(filteredStops.length);
        },
        [stops],
    );

    useEffect(() => {
        if (!filters.length) {
            return;
        }
        onChange(filters);
    }, [filters, onChange]);

    return (
        <div className="trpr-atlas-menu-modal">
            <div className="trpr-atlas-menu-filter__select">
                <MultiSelect
                    ref={multiSelectRef}
                    onChange={onChange}
                    placeholder="Search"
                    options={tags}
                    selectedValues={filters}
                />
            </div>

            <div className="trpr-atlas-menu-filter__footer">
                <span
                    className={classNames("trpr-atlas-menu-filter__footer-copy", { "no-results": totalResults === 0 })}
                >
                    {totalResults > 0 && `${totalResults} results found.`}
                    {totalResults === 0 && "No results found. Try selecting different tags."}
                </span>
                <div className="trpr-atlas-menu-filter__footer-btns">
                    <button
                        className="trpr-atlas__button trpr-atlas__button--secondary"
                        type="button"
                        onClick={clearFilters}
                    >
                        Clear all filters
                    </button>
                    <button className="trpr-atlas__button" type="button" onClick={handleSubmit}>
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AtlasMenuFilters;
